<template>
  <LayoutPage class="news-page reynsluakstur-page">
    <PostsFilter
        v-if="!!posts"
        :posts="posts"
        :filters="filters"
        @getLimitPosts="init()"
        @getSubFilter="subFilter"
    />
  </LayoutPage>
</template>

<script>
import {categories} from '@/staticData/blog'
import LayoutPage from '@/layout/blog'
import PostsFilter from '@/components/Blog/AllPosts/PostsFilter/_index'
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'

export default {
  components: {
    LayoutPage,
    PostsFilter
  },
  data: () => ({
    carType: {}
  }),
  methods: {
    ...mapActions('blog', {
      getDataPage: 'GET_DATA_BLOG_PAGE',
    }),
    ...mapMutations({
      setData: 'SET_DATA'
    }),
    init() {
      if (this.loading) return
      const hasPosts = !!this.dataPage.posts.length
      this.getDataPage({
        categoryId: categories[2].id,
        limit: hasPosts ? this.dataPage.posts.length + this.limit : this.limit,
        carType: this.carType ? this.carType.id : null
      })
    },
    subFilter(val) {
      this.carType = val;
      this.init();
    },
  },
  computed: {
    ...mapState('blog', {
      limit: state => state.limit,
      loading: state => state.loading
    }),
    ...mapGetters('blog', {
      dataPage: 'GET_DATA_BLOG_PAGE'
    }),
    ...mapState({
      lib: state => state.lib,
    }),
    filters() {
      if (this.lib && this.lib.blog_cat) {
        return this.lib.blog_cat.filter(c => (c.cat == 2)).map(c => ({
          id: c.id,
          title: c.name
        }));
      }
      return this.dataPage && this.dataPage.filters
    },
    posts() {
      return this.dataPage && this.dataPage.posts
          ? this.dataPage.posts.filter((post) => post.category_id === 3)
          : null
    }
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    this.setData({
      field: 'blog.blogPage.posts',
      data: []
    })
  }
}
</script>
